export enum OwnerType {
  Course = "Kurs",
  User = "User",
}
